module.exports = __webpack_public_path__ + "img/block02.646a702b.png";